<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="update()">
      <v-icon color="green">update</v-icon>
    </v-btn>
    <span>Update</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    update() {
      this.$emit("update");
    }
  }
};
</script>

<style>
</style>
